import { render, staticRenderFns } from "./CustomerTodoList.vue?vue&type=template&id=fc2258ce&scoped=true&"
import script from "./CustomerTodoList.vue?vue&type=script&lang=js&"
export * from "./CustomerTodoList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTodoList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerTodoList.vue?vue&type=style&index=1&id=fc2258ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2258ce",
  null
  
)

export default component.exports